import {
  Package,
  SearchIcon,
  TriangleAlertIcon,
  XCircle,
} from "@/components/icons";
import { Skeleton } from "@/components/kit";
import type { ProductListItemDTO } from "@/modules/products/domain/types";

type ProductsStatsProps = {
  products: ProductListItemDTO[];
  isLoading?: boolean;
};

function StatCard({
  icon: Icon,
  label,
  value,
  accentClass,
}: {
  icon: typeof Package;
  label: string;
  value: number;
  accentClass: string;
}) {
  return (
    <div className="brand-card flex items-center gap-3 p-4">
      <div
        className={`flex size-10 shrink-0 items-center justify-center rounded-xl ${accentClass}`}
      >
        <Icon />
      </div>
      <div className="flex flex-col gap-0.5">
        <span className="text-muted-foreground text-xs">{label}</span>
        <span className="font-display text-2xl tabular-nums leading-none">
          {value}
        </span>
      </div>
    </div>
  );
}

export function ProductsStats({ products, isLoading }: ProductsStatsProps) {
  if (isLoading) {
    return (
      <div className="grid gap-3 sm:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-[4.5rem] rounded-2xl" />
        ))}
      </div>
    );
  }

  const lowStock = products.filter((p) => p.isLowStock).length;
  const outOfStock = products.filter((p) => p.totalStock <= 0).length;

  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <StatCard
        icon={Package}
        label="ສິນຄ້າທັງໝົດ"
        value={products.length}
        accentClass="bg-primary/20 text-secondary"
      />
      <StatCard
        icon={TriangleAlertIcon}
        label="ໃກ້ໝົດ"
        value={lowStock}
        accentClass="bg-destructive/15 text-destructive"
      />
      <StatCard
        icon={XCircle}
        label="ຫມົດສະຕັອກ"
        value={outOfStock}
        accentClass="bg-muted text-muted-foreground"
      />
    </div>
  );
}
